var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStorePage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0ZM24 1.73494C36.2967 1.73494 46.2651 11.7033 46.2651 24C46.2651 36.2967 36.2967 46.2651 24 46.2651C11.7033 46.2651 1.73494 36.2967 1.73494 24C1.73494 11.7033 11.7033 1.73494 24 1.73494Z",
    fill: "#146EB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5506 13.3975C34.0017 13.3975 34.4529 13.7004 34.6033 14.3062V28.0894C34.6033 28.6952 34.1521 28.9981 33.7009 28.9981H29.0388V33.6935C29.0388 34.1479 28.5877 34.6023 28.1365 34.6023H14.3008C13.6992 34.6023 13.3984 34.1479 13.3984 33.6935V19.7589C13.3984 19.3045 13.6992 19.0016 14.3008 19.0016H18.9628V14.3062C18.9628 13.7004 19.2636 13.3975 19.7148 13.3975H33.5506ZM26.9334 20.6677H15.3535C15.2031 20.6677 15.0527 20.8191 15.0527 20.9706V32.6332C15.0527 32.7848 15.2031 32.9362 15.3535 32.9362H26.9334C27.0838 32.9362 27.2342 32.7848 27.2342 32.6332V20.9706C27.2342 20.8191 27.0838 20.6677 26.9334 20.6677ZM32.4979 15.0635H20.9179C20.7675 15.0635 20.6171 15.215 20.6171 15.3665V18.5472C20.6171 18.6987 20.7675 18.8501 20.9179 18.8501H27.9861C28.5877 18.8501 28.8885 19.3045 28.8885 19.7589V27.0291C28.8885 27.1806 29.0388 27.3321 29.1893 27.3321H32.4979C32.6482 27.3321 32.7987 27.1806 32.7987 27.0291V15.3665C32.7987 15.215 32.6482 15.0635 32.4979 15.0635Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorePage);
export default __webpack_public_path__ + "static/media/store_page.85182aaca9dcc23d328ad1372769a160.svg";
export { ForwardRef as ReactComponent };